import { EventStream } from './EventStreamSubscription';

export const T_IFramePulse = Symbol('IFramePulse');
export interface IFramePulse {
  active: boolean;
  framePulsate: EventStream<number>;
}
